import Vue from '../../../lib/utils/vue3compat/vue.js?vue3';
import VueApollo from '../../../lib/utils/vue3compat/vue_apollo.js?vue3';
import { initVueApp } from '../../../lib/utils/vue3compat/init_vue_app.js?vue3';
import createDefaultClient from '../../../lib/graphql.js?vue3';
import PipelineSummary from '../../../ci/common/pipeline_summary/pipeline_summary.vue?vue3';

Vue.use(VueApollo);

const apolloProvider = new VueApollo({
  defaultClient: createDefaultClient(),
});

export default (selector = '#js-commit-box-pipeline-summary') => {
  const el = document.querySelector(selector);

  if (!el) {
    return;
  }

  const { fullPath, iid, graphqlResourceEtag } = el.dataset;

  initVueApp({
    el,
    name: 'PipelineSummaryRoot',
    apolloProvider,
    component: PipelineSummary,
    props: { fullPath, iid, pipelineEtag: graphqlResourceEtag },
  });
};
